export {
  StaticProvider,
  StaticConsumer,
  StaticContext,
} from './components/StaticContext';

export { default as SMHeader } from './components/Header';

export { default as SMFooter } from './components/Footer';

export {
  DesktopScreen,
  TabletScreen,
  MobileScreen,
  MobileTabletScreen,
} from './components/MediaComponents';

export {
  AuthenticationProvider,
  useAuthentication,
} from './components/Authentication';

export { Recaptcha, useRecaptcha } from './components/Recaptcha';

export { default as Autocomplete } from './components/Autocomplete';

export { default as BasePage } from './components/BasePage';

export { Logo, LogoWithText } from './components/Logos';

export { default as MobileBanner } from './components/MobileBanner';

export { default as ErrorBoundary } from './components/ErrorBoundary';

export {
  FiveHundredErrorPage,
  FiveHundredError,
} from './components/FiveHundredError';

export { default as FourOhFourError } from './components/FourOhFourError';

export { default as ForbiddenError } from './components/ForbiddenError';

export { default as Helmet, HelmetProvider } from './components/Helmet';

export { default as SessionTimeoutModal } from './components/SessionTimeoutModal';

export { default as ReleaseToggle } from './components/ReleaseToggle';

export { default as CookieBanner } from './components/CookieBanner';

export { default as ErrorCard } from './components/ErrorCard';

export { default as SkeletonLoader } from './components/SkeletonLoader';

export { default as Treatment } from './components/Experiments/Treatment';
export { useExperiment } from './components/Experiments';
export { default as getMyTeamMenuItems } from './helpers/TeamMenuHelpers';

export { default as getHelpLink } from './helpers/getHelpLink';
export {
  initializeErrorHandler as initializeClientErrorHandler,
  errorHandler as clientErrorHandler,
} from './helpers/errorHandler';
export { default as BrowserGuard } from './components/BrowserGuard';
